/**
 * Service to handle API calls for languages.
 * Created on 01-01-2025
 * Modified on 13-01-2025
 */
import axios from "../services/axiosService.js";
import CommonService from "../services/commonService.js";

//  Mock Data imports
import reviewData from "../assets/data/review.json";

class ReviewService {
  commonService = new CommonService();
  constructor() {
    this.apiPointer = process.env.REACT_APP_WEB_API_POINTER;
    this.apiFolder = process.env.REACT_APP_WEB_API_FOLDER;

    //  API url methods
    this.apiUrl = {
      getReview: "/Transformation/GetReviews",
      updateReview: "/Transformation/UpdateReviews"
    };

    //  List of API endpoints to point to local mock data
    this.mockApiUrl = [
      // 'getReview',
      // 'updateReview'
    ];
  }

  /**
   * Function to get language
   * @param {*} project_UUID
   * @returns
   */
  getReview = async (varData) => {
    try {
      if (
        this.apiPointer.toLowerCase() === "local" ||
        this.mockApiUrl.includes("getReview")
      ) {
        return Promise.resolve(reviewData);
      } else {
        const vApiEndpoint = this.commonService.getAPIUrl();
        const vUrl = vApiEndpoint + this.apiFolder + this.apiUrl.getReview;
        return await axios.post(vUrl, varData).then((data) => {
          const datareturn = data?.data;
          return datareturn;
        });
      }
    } catch (error) {
      this.commonService.logException(error, "ReviewService", "getReview");
    }
  };

  /**
   * Function to update review with inserted or discarded
   * @param {*} vData
   * @returns 
   */
  updateReview = async (vData) => {
    try {
      if (
        this.apiPointer.toLowerCase() === "local" ||
        this.mockApiUrl.includes("updateReview")
      ) {
        return Promise.resolve('Review updated successfully');
      } else {
        const vApiEndpoint = this.commonService.getAPIUrl();
        const vUrl = vApiEndpoint + this.apiFolder + this.apiUrl.updateReview;
        return await axios
          .put(vUrl, vData)
          .then((response) => {
            const res = response;
            return res;
          });
      }
    } catch (error) {
      this.commonService.logException(error, "ReviewService", "updateReview");
    }
  }
}

export default ReviewService;
